/**
 * Mirrors the API's `AuditEventType` (`EventTypeId` on the access-log ledger). Values are persisted
 * server-side, so they must not be renumbered here either.
 *
 * The patient-facing Type filter is coarser than this enum: "Exported" covers both `Download` and
 * `Transmit`, which is why the search request takes a *set* of ids. See
 * `toEventTypeIds()` in `access-log-request.functions.ts`.
 */
export enum AuditEventType {
  View = 1,
  Print = 2,
  Download = 3,
  Transmit = 4,
}

/**
 * Mirrors the API's coarse `AccessRelationshipType` — the self-versus-delegated snapshot taken at
 * access time.
 *
 * `SelfOrDefault` is deliberately NOT treated as proof of self-access: the server documents it as the
 * value the audit filter also falls back to when no relationship was stamped at all. The detail
 * relationship disambiguates, so read the pair, never this alone.
 */
export enum AccessRelationshipType {
  SelfOrDefault = 1,
  Delegated = 2,
}
